var map = {
	"./clear.svg": "./svg/clear.svg",
	"./facebook.svg": "./svg/facebook.svg",
	"./instagram.svg": "./svg/instagram.svg",
	"./logotipo-footer.svg": "./svg/logotipo-footer.svg",
	"./logotipo.svg": "./svg/logotipo.svg",
	"./menu.svg": "./svg/menu.svg",
	"./rss.svg": "./svg/rss.svg",
	"./search.svg": "./svg/search.svg",
	"./share-facebook.svg": "./svg/share-facebook.svg",
	"./share-linkedIn.svg": "./svg/share-linkedIn.svg",
	"./share-twitter.svg": "./svg/share-twitter.svg",
	"./share-whatsapp.svg": "./svg/share-whatsapp.svg",
	"./whatsapp.svg": "./svg/whatsapp.svg",
	"./youtube.svg": "./svg/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./svg sync recursive \\.svg$";